import { motion } from "framer-motion";

const COLLABORATORS = [
  "Baron Davis",
  "Stan Lee",
  "Scopely",
  "Warner Bros",
];

export default function About() {
  return (
    <section
      id="about"
      data-testid="about-section"
      className="relative py-24 md:py-32 border-t border-white/5"
    >
      <div className="mx-auto max-w-7xl px-6 md:px-10 lg:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16 items-center">
          <motion.div
            initial={{ opacity: 0, x: -20 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.7 }}
            className="lg:col-span-4 flex justify-center lg:justify-start"
          >
            <div className="relative h-56 w-56 md:h-64 md:w-64 rounded-full p-[2px] bg-gradient-to-br from-[#00d4ff]/60 via-[#00d4ff]/10 to-transparent">
              <div className="h-full w-full rounded-full overflow-hidden bg-[#13131a]">
                <img
                  src="https://customer-assets.emergentagent.com/job_power-volta/artifacts/9tvz8tdr_36990f8b-8e20-4c60-86de-3018d93269a3.PNG"
                  alt="Ramon Govea, Founder of AI Volta"
                  loading="lazy"
                  className="h-full w-full object-cover object-[60%_22%] scale-[1.3]"
                />
              </div>
              <span className="absolute -bottom-2 -right-2 h-10 w-10 rounded-full border border-[#00d4ff]/40 bg-[#0a0a0f] shadow-[0_0_20px_rgba(0,212,255,0.4)]" />
            </div>
          </motion.div>

          <div className="lg:col-span-8">
            <span
              className="text-xs uppercase tracking-[0.22em] text-[#00d4ff]/90"
              data-testid="about-eyebrow"
            >
              About AI Volta
            </span>
            <motion.h2
              initial={{ opacity: 0, y: 16 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-80px" }}
              transition={{ duration: 0.6 }}
              className="font-display mt-3 text-3xl sm:text-4xl md:text-5xl font-semibold tracking-tight"
              data-testid="about-headline"
            >
              Who We Are
            </motion.h2>
            <p className="mt-5 text-zinc-300 text-base md:text-lg leading-relaxed max-w-2xl">
              AI Volta is led by{" "}
              <span className="text-white font-medium">Ramon Govea</span> — a
              senior creative producer with 15+ years operating at the
              intersection of Hollywood, media, and brand storytelling. His
              background spans work with Baron Davis, Stan Lee, Scopely, and
              Warner Bros. Today, he brings that creative leadership to
              AI‑powered business solutions — delivering agency‑grade results
              with smaller budgets, faster timelines, and tighter control.
            </p>

            <div className="mt-10">
              <div className="text-[11px] uppercase tracking-[0.22em] text-zinc-500">
                Trusted &amp; Collaborated With
              </div>
              <div className="mt-4 grid grid-cols-2 sm:grid-cols-4 gap-x-6 gap-y-4">
                {COLLABORATORS.map((c) => (
                  <div
                    key={c}
                    data-testid={`about-logo-${c.toLowerCase().replace(/\s+/g, "-")}`}
                    className="font-display text-base sm:text-lg font-semibold tracking-tight text-white/40 hover:text-white/70 transition-colors"
                  >
                    {c}
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
